var $5a9f8486f8b8837e$exports = {};
$5a9f8486f8b8837e$exports = {
    "Empty": `Tom`
};


export {$5a9f8486f8b8837e$exports as default};
//# sourceMappingURL=nb-NO.module.js.map
